/**
 * @Description: 统计全校男女生数量情况
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-09-10 15:36:23
 * @LastEditors: 琴时
 * @LastEditTime: 2021-09-24 17:15:42
 * @FilePath: \ly-sm-yxxt-ui\src\containers\Show-new\_CenterBottomBox1.js
 */
import React from 'react'
import { Row, Col } from 'antd'
import ReactEchartsCore from 'echarts-for-react/lib/core'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/component/title'
import 'echarts/lib/chart/pie'
import styles from './styles.css'
import NHFetch from '../../utils/NHFetch.js'

const yxxtBasicUrl = 'api/zhxg-yxxt' //迎新管理服务后台接口基础路径
const errMaxCount = 3 // 请求异常最大次数
const speed = 30 * 1000 //轮询时间间隔
export default class _CenterBottomBox1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errCount: 0, //连续请求错误次数
      barData: {}, //各学院报到统计数据
    }
    this.polling
  }

  componentDidMount() {
    this.getData()
  }

  // 组件卸载时清除定时器
  componentWillUnmount() {
    if (this.polling) {
      clearTimeout(this.polling)
    }
  }
  getData = () => {
    NHFetch(yxxtBasicUrl + '/sstj/getSchoolSexdSituationByLcid', 'GET',{pkid: this.props.pkid})
      .then(res => {
        if (res && res.data) {
          this.setState({ errCount: 0, barData: res.data })
        }
      })
      .catch(err => {
        let errCount = this.state.errCount
        //如果请求异常次数未超过最大次数限制，则继续尝试
        if (errCount < errMaxCount) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: errCount + 1 })
        } else {
          //异常超过3次后终止轮询
          if (this.polling) {
            clearTimeout(this.polling)
          }
        }
      })
  }

  getPieOption = () => {
    const { barData = {} } = this.state
    const option = {
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)',
      },
      legend: {
        bottom: 10,
        left: 'center',
        textStyle: { color: '#fff' },
        data: [
          {
            name: '男生人数',
            icon: 'circle',
          },
          {
            name: '女生人数',
            icon: 'circle',
          },
        ],
      },
      series: [
        {
          name: '男女比例',
          type: 'pie',
          radius: '55%',
          center: ['50%', '40%'],
          hoverAnimation: false, //禁止悬浮动画
          data: [
            {
              value: barData.femaleCount ? barData.femaleCount : 0,
              name: '男生人数',
              itemStyle: {
                hoverAnimation: false, //禁止悬浮动画
                normal: {
                  color: {
                    type: 'pie',
                    colorStops: [
                      {
                        offset: 0,
                        color: '#088EFF', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#0E51F3', // 100% 处的颜色
                      },
                    ],
                    globalCoord: false, // 缺省为 false
                  },
                },
              },
            },
            {
              value: barData.maleCount ? barData.maleCount : 0,
              name: '女生人数',
              itemStyle: {
                hoverAnimation: false, //禁止悬浮动画
                normal: {
                  color: {
                    type: 'pie',
                    colorStops: [
                      {
                        offset: 0,
                        color: '#FF5D31', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#D234CC', // 100% 处的颜色
                      },
                    ],
                    globalCoord: false, // 缺省为 false
                  },
                },
              },
            },
          ],
          label: {
            // 线上文字的样式
            normal: {
              formatter: '{c|{c}}', // 线上文字
              borderWidth: 20,
              borderRadius: 4,
              padding: [0, -13],
              rich: {
                c: {
                  color: '#fff',
                  fontSize: 12,
                  lineHeight: 25,
                },
              },
            },
          },
        },
      ],
    }
    return option
  }

  render() {
    const { barData = {} } = this.state
    const { femaleRatio = 0, maleRatio = 0 } = barData
    return (
      <div className={styles.box_2_bottom_com}>
        <span className={styles.box_title} style={{ top: '0px' }}>
          男女生比例
        </span>
        <div className={styles.layout}>
          <div className={styles.layout_l}>
            <ReactEchartsCore
              style={{ width: '100%', height: '100%' }}
              echarts={echarts}
              option={this.getPieOption()}
              notMerge={true}
              lazyUpdate={true}
            />
          </div>
          <div className={styles.layout_r}>
            <div>
              <div className={styles.box_2_bottom_bg1}></div>
              <span className={styles.span_b_r1}>
                {(femaleRatio * 100).toFixed(2)}%
              </span>
            </div>
            <div>
              <div className={styles.box_2_bottom_bg2}></div>
              <span className={styles.span_b_r2}>
                {(maleRatio * 100).toFixed(2)}%
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/Show-new/_CenterBottomBox1.js